import {Component} from "@angular/core";

@Component({
  selector: "release-notes",
  templateUrl: "./release-notes.template.pug",
})

export class ReleaseNotesComponent {
  releaseNotesUrl = "/releasenotes.md";

  constructor() {}
}
